import React from 'react';

export const RedDot = <div className='red-dot'></div>;

export const selectedSvg = (
  <svg
    width='8px'
    height='38px'
    viewBox='0 0 8 38'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    className='selected'
  >
    <title>selected</title>
    <g id='控件' stroke='none' strokeWidth='1' fill='none'>
      <g
        id='✦-Navigation/01.Left-Menu/03.Elements-01.L1/02.Parent/03.Selected/01.Purple_short'
        transform='translate(-144.000000, 0.000000)'
        fill='#F9F9F9'
      >
        <path
          d='M144,38 C144,28 152,27 152,19 C152,11 144,10 144,0 C144,0 144,6.33333333 144,19 C144,31.6666667 144,38 144,38 Z'
          id='selected'
          transform='translate(148.000000, 19.000000) scale(-1, 1) translate(-148.000000, -19.000000) '
        ></path>
      </g>
    </g>
  </svg>
);
